// src/i18n/index.ts
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import zh from './locales/zh.json'
import en from './locales/en.json'
import japanese from './locales/japanese.json'
import french from './locales/french.json'
import korean from './locales/korean.json'
import german from './locales/german.json'
import russian from './locales/russian.json'
import malay from './locales/malay.json'
import spanish from './locales/spanish.json'
import italian from './locales/italian.json'
import hungarian from './locales/hungarian.json'
import bulgaria from './locales/bulgaria.json'
import czech from './locales/czech.json'
import croatian from './locales/croatian.json'
import romanian from './locales/romanian.json'
import albanian from './locales/albanian.json'
import thai from './locales/thai.json'
import vietnamese from './locales/vietnamese.json'


// 读取缓存语言
const LANG_KEY = 'APP_LANG'
const cachedLang = localStorage.getItem(LANG_KEY) || 'en'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      zh: { translation: zh },
      en: { translation: en },
      japanese: { translation: japanese },
      french: { translation: french },
      korean: { translation: korean },
      german: { translation: german },
      russian: { translation: russian },
      malay: { translation: malay },
      spanish: { translation: spanish },
      italian: { translation: italian },
      hungarian: { translation: hungarian },
      bulgaria: { translation: bulgaria },
      czech: { translation: czech },
      croatian: { translation: croatian },
      romanian: { translation: romanian },
      albanian: { translation: albanian },
      thai: { translation: thai },
      vietnamese: { translation: vietnamese },
    },
    lng: cachedLang,          // 默认语言 zh/en
    fallbackLng: 'en',  // 兜底语言
    interpolation: {
      escapeValue: false, // React 不需要转义
    },
  })


// 切换语言时记住
i18n.on('languageChanged', (lng) => {
  localStorage.setItem(LANG_KEY, lng)
})


export default i18n
